let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("kkgDQ")).then(() => parcelRequire('9Qg7T'));